import { DOCUMENT, inject, Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class SeoService {
    private readonly document = inject(DOCUMENT);

    public updateCanonicalUrl(canonicalUrl: string): void {
        let link = this.document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

        if (!link) {
            link = this.document.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.document.head.appendChild(link);
        }

        link.setAttribute('href', canonicalUrl);
    }

}